export const CREATE_COST_CODE_CATEGORY = 'createCostCodeCategory';
export const FETCH_COST_CODE_CATEGORY_BY_ID = 'fetchCostCodeCategoryById';
export const UPDATE_COST_CODE_CATEGORY = 'updateCostCodeCategory';
export const FETCH_ORGANIZATION_COST_CODE_CATEGORIES = 'fetchOrganizationCostCodeCategories';
